import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

/**
 * Builds a login URL with the current page as the return URL
 * @param returnUrl - Optional custom return URL. If not provided, uses current location
 * @returns Complete login URL with return parameter
 */
export const buildLoginUrlWithReturn = (returnUrl?: string): string => {
  const baseLoginUrl = `${URL_ORIGINAL_WEBSITE}/accounts/login`;

  const currentReturnUrl = returnUrl || window.location.href;

  try {
    const currentUrl = new URL(currentReturnUrl);
    const returnPath = currentUrl.pathname + currentUrl.search + currentUrl.hash;

    if (!returnPath.includes("/accounts/login") && !returnPath.includes("/accounts/logout")) {
      const loginUrl = new URL(baseLoginUrl);
      loginUrl.searchParams.set("next", returnPath);
      return loginUrl.toString();
    }
  } catch (error) {
    console.warn("Failed to parse return URL for login redirect:", error);
  }

  return baseLoginUrl;
};
